import * as React from "react";
const SvgFiRrCandySweet = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M23.849 9.68c-.104-.759-1.015-1.087-1.587-.578l-1.418 1.261c-.773-4.182-4.441-7.362-8.843-7.362S3.93 6.179 3.157 10.362L1.74 9.102c-.573-.509-1.484-.18-1.587.579A17 17 0 0 0 0 12c0 .915.067 1.697.152 2.319.103.759 1.014 1.088 1.587.579l1.418-1.26C3.93 17.82 7.598 20.999 12 20.999s8.07-3.18 8.843-7.362l1.418 1.261c.572.509 1.483.18 1.587-.578.085-.623.152-1.404.152-2.32s-.067-1.697-.152-2.32zM5 12c0-3.859 3.141-7 7-7a7 7 0 0 1 2.22.367L5.367 14.22A7 7 0 0 1 5 12m1.329 4.087 9.758-9.758c.61.441 1.145.976 1.586 1.586l-9.758 9.758a7 7 0 0 1-1.586-1.586M12 19.001c-.776 0-1.52-.132-2.219-.366l8.852-8.852c.234.698.366 1.443.366 2.219 0 3.859-3.141 7-7 7z"
    />
  </svg>
);
export default SvgFiRrCandySweet;
